const AvailableIndices = {
    post: {
        index: 'prod_atos-post',
        hitsPerPage: 4,
    },
    page: {
        index: 'prod_atos-page',
        hitsPerPage: 2,
    },
    video: {
        index: 'prod_atos-video',
        hitsPerPage: 1,
    },
};
export default AvailableIndices;
